import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

import { AppModule } from './app/app.module';
import {
    endMsalPopup,
    returningMsalPopupNonce,
} from './app/pages/login/msal-popup';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

function bootstrap(): void {
    platformBrowser()
        .bootstrapModule(AppModule, {
            applicationProviders: [provideZoneChangeDetection()],
        })
        .catch(err => console.error(err));
}

// msal-browser 5 popups return to the app's own redirect URI with the auth
// response in the fragment. There, hand the response back to the main window
// instead of bootstrapping the app.
const popupNonce = returningMsalPopupNonce();
if (popupNonce) {
    endMsalPopup(popupNonce);
    // The bridge strips the response from the URL and closes the window. Only
    // a script-opened popup can close; a normal tab that followed a link with
    // such a fragment stays open, so start the app there as usual.
    broadcastResponseToMainFrame()
        .catch(err => console.error(err))
        .finally(() => {
            if (!window.closed) bootstrap();
        });
} else {
    bootstrap();
}
